import { useLayoutEffect, useState } from 'react';

import { ITimerStatus } from '../components/atoms/player/timer-tooltip/timer-tooltip';

const useAdvRewarded = (timerTooltipTimeout?: number): [ITimerStatus, string] => {
  const [timerElapsed, setTimerElapsed] = useState<string>('');
  const [timerStatus, setTimerStatus] = useState<ITimerStatus>(null);

  useLayoutEffect(() => {
    const advRewardedElapsedCallback = (event: CustomEvent) => {
      setTimerElapsed(event.detail.elapsed);
    };
    const advRewardedStartCallback = () => {
      setTimerStatus('start');
      const timeoutId = setTimeout(() => {
        setTimerStatus('progress');
        clearTimeout(timeoutId);
      }, timerTooltipTimeout);
    };
    const advRewardedResumeCallback = () => {
      setTimerStatus('progress');
    };
    const advRewardedEndCallback = () => {
      setTimerStatus('end');
      const timeoutId = setTimeout(() => {
        setTimerStatus(null);
        clearTimeout(timeoutId);
      }, timerTooltipTimeout);
    };
    document.addEventListener('ADV_REWARDED_START', advRewardedStartCallback);
    document.addEventListener('ADV_REWARDED_RESUME', advRewardedResumeCallback);
    document.addEventListener('ADV_REWARDED_END', advRewardedEndCallback);
    document.addEventListener('ADV_REWARDED_ELAPSED', advRewardedElapsedCallback);

    // Triggering this event we can restore a timer when a reload event occurs
    document.dispatchEvent(new CustomEvent('ADV_REWARDED_RESUME_REQUEST'));

    return () => {
      document.removeEventListener('ADV_REWARDED_START', advRewardedStartCallback);
      document.removeEventListener('ADV_REWARDED_RESUME', advRewardedResumeCallback);
      document.removeEventListener('ADV_REWARDED_END', advRewardedEndCallback);
      document.removeEventListener('ADV_REWARDED_ELAPSED', advRewardedElapsedCallback);
    };
  }, []);
  return [timerStatus, timerElapsed];
};

export default useAdvRewarded;
